// src/app/services/posthog.service.ts
import { DestroyRef, Injectable, NgZone } from "@angular/core";
import posthog from "posthog-js";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
@Injectable({ providedIn: "root" })
export class PosthogService {
  constructor(
    private ngZone: NgZone,
    private router: Router,
    private destroyRef: DestroyRef,
  ) {
    this.initPostHog();
  }
  private initPostHog() {
    this.ngZone.runOutsideAngular(() => {
      posthog.init(environment.posthogKey, {
        api_host: environment.posthogHost,
        defaults: '2026-05-30',
        autocapture: false,
        capture_performance: false,
        capture_heatmaps: false,
        disable_session_recording: true,
      });
    });
  }

  /** Reset identity/groups, e.g. on logout or a fresh checkout session. */
  reset() {
    posthog.reset();
  }
}
